const searchModal = {
    data () {
		return {
            isOpened: false,
            errorMsgs:[]
        }
    },
	mounted () {
	},
    methods: {
        toggleSearch(){
            this.isOpened ? this.closeSearch() : this.openSearch()
        },
        openSearch(){
            if(headerMenuDevicesMounted)
                headerMenuDevicesMounted.closeMenu()

            jQuery('html, body').addClass('search-modal-opened')
            this.isOpened = true
        },
        closeSearch(){
            jQuery('html, body').removeClass('search-modal-opened')
            this.isOpened = false
        },
        searchFailed(messages) {
            this.errorMsgs = [].concat(messages)
        }
    }
}

var searchModalApp = Vue.createApp(searchModal)
if(document.querySelector("#search-app")){
    searchModalApp.directive('init', initDirective);
    searchModalApp.component("search-input", searchInput);
    searchModalApp.component("b-auto-completer", bAutoCompleter);
    searchModalApp.component("alert-danger", alertDanger)
    searchModalApp.mount("#search-app")
}

    